import React from 'react';
import CustomTextField from '../../../../common/CustomTextField';
import { MAX_LENGTH_CONSTRAINTS } from '../../../../common/constants';
import { ONLY_NUMBER_REGEX } from '../../../../../constRegex';

const ExceptionNumberInput = ({
  classes,
  label,
  value,
  onChange,
  error,
  maxLength,
}) => {
  const handleChange = (val) => {
    onChange && onChange(val);
  };

  return (
    <CustomTextField
      id="adeNumber"
      label={label}
      handleChange={handleChange}
      error={error}
      value={value ?? ''}
      className={classes.fullWidth}
      type="text"
      inputProps={{
        maxLength: maxLength ?? MAX_LENGTH_CONSTRAINTS.DELIVERY_PRO_FORM.ADE_NUMBER,
        pattern: ONLY_NUMBER_REGEX,
      }}
    />
  );
};

export default ExceptionNumberInput;
